/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Grid row for black list
 */
export interface BlackListInfo { 
    /**
     * Search result
     */
    searchResult: string;
    /**
     * Matched string
     */
    match: string;
    /**
     * Name
     */
    name: string;
    /**
     * Word count matched
     */
    wordCount: number;
    /**
     * Black list details list
     */
    details: object;
}

